import { defineMessage } from 'services/localization';

export const messages = {
    approverOnBehalfOfText: defineMessage('you_are_approving_on_behalf_of'),
    reviewerOnBehalfOfText: defineMessage('you_are_reviewing_on_behalf_of'),
};
